import { Injectable } from '@angular/core';
import { SecureApi } from '../core/secure.api';

@Injectable()
export class PatientsService {
    STATUS = {
        ACTIVE:   'active',
        ARCHIVED: 'archived',
        DELETED:  'deleted',
        SHARED:   'shared',
    };

    LATEST_ACTION = {
        new_map_available : 'New symptom map available',
        di_opened         : 'Diagnostic Interview is in progress',
        di_reseted         : 'Diagnostic Interview was reseted',
        se_overdue        : 'Self Evaluation is overdue',
        reminder_sent     : 'Reminder {{reminder_count}} has been sent by {{executed_by}}',
        reminder_overdue      : 'Reminder {{reminder_count}} is overdue',
        se_completed          : 'Diagnostic Interview is ready',
        se_fully_completed    : 'Diagnostic Interview is fully ready',
        di_completed          : 'Diagnostic Interview has been completed',
        renew_self_report      : 'Renewed self-report',
        questionnaire_archived      : 'Questionnaire archived',
        archived_patient       : 'Archived by {{executed_by}}',
        se_deleted             : 'Self Evaluation has been deleted',
        di_deleted           : 'Questionnaire was deleted',
        assignment_sent    : 'Newly assigned by {{executed_by}} - {{clinic_id}}',
        transfer_sent      : 'New transfer',
        reactivate_patient  : 'Reactivated by {{executed_by}}',
        assign_request_sent : 'Transfer request has been send to {{assign_to}} - {{clinic_id}}',
        assignment_accepted : 'Transfer request has been accepted by {{user_id}} - {{clinic_id}}',
        assignment_revoked : 'Transfer request has been revoked by {{user_id}}',
        diagnosis_set      : 'Diagnosis set',
    };

    TASKS = {
        sendreminder:           'Send reminder task',
        newmap:                 'New symptom map task',
        exportmap:              'Export Symptom map task',
        assignpatient:          'Assign patient task',
        sendse:                 'Send Self report task'
    };
    MAP_EXISTS = 4;

    constructor(public secureApi: SecureApi) {
    }

    getPatients() {
        return this.secureApi.get('patients/index');
    }

    getPatientsWithParams(data?: {}) {
        let params: string = '';
        params += data && data['active'] >= 0   ?     'active=' + data['active'] : '';
        params += data && data['shared'] >= 0   ?     '&shared=' + data['shared'] : '';
        params += data && data['archived'] >= 0 ?     '&archived=' + data['archived'] : '';
        params += data && data['deleted'] >= 0  ?     '&deleted=' + data['deleted'] : '';
        return this.secureApi.get('patients/get?' + params);
    }

    getDiQuickPathPatients() {
        return this.secureApi.get('di-quickpath');
    }

    getSVG(id: number) {
        return this.secureApi.get('symptom-map/' + id);
    }

    getComparisonSVG(id1: number, id2: number, language, hasProposalData = 0) {
        return this.secureApi.get('comparison-map/' + id1 + '/' + id2 + '/' + language + '/' + hasProposalData);
    }

    read(id = 0) {
        return this.secureApi.get('patients/read/' + id);
    }

    profile(id = 0) {
        return this.secureApi.get('patients/profile/' + id);
    }

    readAssignmentData(id = 0) {
        return this.secureApi.get('patient/assignment/' + id);
    }

    saveAssignmentData(patientId, receiverDoctorId, assignmentNote, clinicId) {
        return this.secureApi.post('patient/assign/' + patientId, {
            'assignee_id': receiverDoctorId,
            'assignment_note': assignmentNote,
            'assignee_clinic_id'  : clinicId
        }, false);
    }

    readInviteData(id = 0) {
        return this.secureApi.get('patient/invite/' + id);
    }

    saveInviteData(id, data) {
        return this.secureApi.post('patient/invite/' + id, data, false);
    }

    readSymptomMap(patientId) {
        return this.secureApi.get('patient/maps/' + patientId);
    }

    submitTransferdPatient(status, patientId) {
        return this.secureApi.post('patient/assignemnt/response/',
            {'status': status, 'patient_assignment_id': patientId},
            false);
    }

    removeAssignedDoctor(patientId, doctorId) {
        return this.secureApi.post('patient/assignemnt/revoke/',
            {'patient_id': patientId, 'assign_to': doctorId},
            false);
    }

    revokeOnPatientAgreement(patientId, options) {
        return this.secureApi.post('patient/revoke-agreement/' + patientId,
            {'options': options},
            false);
    }

    getPatientMarked(patientId) {
        return this.secureApi.get('patient/marked/' + patientId);
    }

    updatePatientMarked(patientId, params) {
        return this.secureApi.post('patient/update-marked/' + patientId, params, false);
    }

    isDIFinished(status){
        return this.LATEST_ACTION.di_completed === status || this.LATEST_ACTION.di_opened === status || this.LATEST_ACTION.diagnosis_set === status;
    }

    isRenew(status){
        return this.LATEST_ACTION.renew_self_report === status;
    }

    isOverdue(status){
        return this.LATEST_ACTION.se_overdue === status || this.LATEST_ACTION.reminder_overdue === status;
    }

    isDiOpened(status){
        return this.LATEST_ACTION.di_reseted === status || this.LATEST_ACTION.di_opened === status;
    }

    isSEFinished(status){
        return this.LATEST_ACTION.se_completed === status || this.LATEST_ACTION.se_fully_completed === status;
    }

    isNewMapAvailable(status){
        return this.LATEST_ACTION.new_map_available === status;
    }

    isArchivedQuestionnaire(status){
        return this.LATEST_ACTION.questionnaire_archived === status;
    }

    isquestionnaireDeleted(status){
        return this.LATEST_ACTION.di_deleted === status || this.LATEST_ACTION.se_deleted === status;
    }

    getStatus(patient) {
        const action = patient.latest_action.template;
        for(let key in this.LATEST_ACTION) {
            if (action.indexOf(this.LATEST_ACTION[key]) >= 0) {
                return key;
            }
        }
    }

    haveActiveQuestion(seQuestionnaire, diQuestionnaire){
        if ((seQuestionnaire == null || diQuestionnaire == null) || (seQuestionnaire.archived && diQuestionnaire.archived) ) {
            return false;
        }

        return true;
    }

    canArchiveQuestion(seQuestionnaire, diQuestionnaire, action){

        if ((seQuestionnaire == null || diQuestionnaire == null)) {
            return false;
        }

        return action.indexOf(this.LATEST_ACTION.di_completed) >= 0
                || action.indexOf(this.LATEST_ACTION.renew_self_report) >= 0 
                || seQuestionnaire.step >= this.MAP_EXISTS 
                || seQuestionnaire.archived;

    }

    getLastestDI(questionnaire) {
        if (questionnaire.length > 0) {
            return questionnaire[0];
        }

        return null;
    }

    getLastestSE(questionnaire) {
        if (questionnaire.length > 1) {
            return questionnaire[1];
        }

        return null;
    }

    getprofileStatus(status) {
        if (this.LATEST_ACTION.assign_request_sent === status
            || this.LATEST_ACTION.assignment_accepted === status 
            || this.LATEST_ACTION.assignment_revoked === status
            || this.LATEST_ACTION.assignment_sent === status
            || this.LATEST_ACTION.transfer_sent === status
            || this.LATEST_ACTION.reactivate_patient === status) {
            return status + ' profile';
        }

        return status;
    }

    sendDownloadDocumentEmail(patient) {
        return this.secureApi.post('coordinator/send-download-email/' + patient.id, {}, false);
    }

    assignPatientToClinicPool(patient) {
        return this.secureApi.post('patients/assign-to-coordinator/' + patient.id, {}, false);
    }

    generatePatientToken(patient) {
        return this.secureApi.get('b2c-patients/gererate-token/' + patient.id);
    }
}
